module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.2-412c87b278332a29612936cc6cf319f5.png";